import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, Form, Table } from 'react-bootstrap';
import { BarChart, XAxis, YAxis, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { RiDownloadCloudFill } from "react-icons/ri";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import { UserContext } from '../../context/UserContextProvider';
import APIServicenew from '../../utils/APIGeneralService';
import Filter from "./Filter";
import MomListFilter from "../mom/MomListFilter";
import { formatDateTime, formatDateDMY, formatTime, capitalizeFirstLetter } from "../../utils/Helper";
import Paginator from "../../components/common/Pagination";
import { toPng } from 'html-to-image';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MisReport = () => {
    const currentYear = new Date().getFullYear();
    const [activeTab, setActiveTab] = useState("listView");
    const [activeSection, setActiveSection] = useState("tabs-1");
    const { accessToken, logout } = useContext(UserContext);
    const permissionscontext = useMenuPermissions('/admin/mis-report');
    const [graph, setGraph] = useState({
        labels: [],
        datasets: [
            {
                label: 'MOM',
                data: [],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            }
        ]
    });
    const [expenses, setExpenses] = useState({
        labels: [],
        datasets: [
            {
                label: 'MOM',
                data: [],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            }
        ]
    });
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const headers = { "auth-token": authToken, authorization: accessToken };
    const navigate = useNavigate();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [years, setYears] = useState([2024, 2025]); // Initialize years
    const [type, setType] = useState('monthly');
    const [month, setMonth] = useState('');
    const [selectedExpensesYear, setExpensesSelectedYear] = useState(currentYear);
    const [expensesYears, setExpensesYears] = useState([2024, 2025]); // Initialize years
    const [expensestype, setExpensesType] = useState('monthly');
    const [expensesmonth, setExpensesMonth] = useState('');
    const [momId, setMOMId] = useState('');
    const [momName, setMOMName] = useState('');
    const [showTableFilter, setShowTableFilter] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({}); // Initialize filters state here
    const [otherData, setOtherData] = useState([]);
    const [momList, setMomList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [otherTotal, setOtherTotal] = useState(0);
    const [download, setDownload] = useState(false);
    const [count, setCount] = useState(0);
    const limit = 10;
    const graphSectionRef = useRef(null);
    const [selectedRange, setSelectedRange] = useState("");
    const [momData, setMOMData] = useState([]);

    const chartRef = useRef(null); // Reference for the chart instance
    const chartERef = useRef(null); // Reference for the chart instance

    const monthsMap = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sept",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    };

    useEffect(() => {
        fetchOtherData();
        fetchMOM();
    }, []);

    useEffect(() => {
        fetchMomList(currentPage, filters);
    }, [currentPage, filters]);

    const fetchMomList = async (page = 1, filters) => {
        const params = {
            ...filters,
            offset: (page - 1) * limit,
            limit: limit,
        };

        const queryString = Object.entries(params)
            .filter(
                ([_, value]) => value !== "" && value !== undefined && value !== null
            )
            .map(([key, value]) => `${key}=${value}`)
            .join("&");

        try {
            const response = await APIServices.get(
                `/admin/mom/list?${queryString}`,
                headers
            );
            if (response?.status === 200) {
                setMomList(response?.data?.list || []);
                setCount(response?.data?.count)
                setTotalCount(Math.ceil(response?.data?.count / limit) || 0); // Corrected
            } else if (response?.status === 401) {
                logout();
                navigate("/");
            } else {
                setMomList([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setMomList([]);
            setTotalCount(0);
        }
    };
    useEffect(() => {
        fetchGraphData(type, selectedYear, month);
    }, [selectedYear, type, month, filters]);

    useEffect(() => {
        fetchExpenseData(expensestype, selectedExpensesYear, expensesmonth, momId);
    }, [selectedExpensesYear, expensestype, expensesmonth, momId]);

    const handleTypeChange = (event) => {
        setType(event.target.value);
        setMonth('');
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange = (event) => {
        setMonth(event.target.value);
    };

    const handleExpensesTypeChange = (event) => {
        setExpensesType(event.target.value);
        setExpensesMonth('');
    };

    const handleExpensesYearChange = (event) => {
        setExpensesSelectedYear(event.target.value);
    };

    const handleExpensesMonthChange = (event) => {
        setExpensesMonth(event.target.value);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleMOMChange = (event) => {
        let mom_id = event.target.value
        setMOMId(event.target.value);
        const foundAgenda = momData.find(item => item.id === mom_id);
        setMOMName(foundAgenda?.agenda)
    };

    const fetchOtherData = async () => {
        try {
            const response = await APIServices.get(
                `admin/mis_report/other_summary`,
                headers
            );
            if (response?.status === 200) {
                const otherData = response?.data?.list || [];  // Ensure we have an array
                let otherTotal = 0;
                otherData.forEach(item => {
                    otherTotal += Number(item.value) || 0; // handle non-numeric values
                });
                setOtherTotal(otherTotal);
                setOtherData(otherData);
            } else if (response?.status === 401) {
                logout();
                navigate("/");
            } else {
                setOtherData([]);
            }
        } catch (error) {
            console.error("Error fetching other data:", error);
            setOtherData([]);
        }
    };

    const fetchMOM = async () => {
        try {
            const response = await APIServices.get(
                `admin/mom/short_list`,
                headers
            );
            if (response?.status === 200) {
                const momData = response?.data?.list || [];  // Ensure we have an array
                console.log("momData", momData)
                setMOMData(momData);
            } else if (response?.status === 401) {
                logout();
                navigate("/");
            } else {
                setMOMData([]);
            }
        } catch (error) {
            console.error("Error fetching other data:", error);
            setMOMData([]);
        }
    };

    const fetchGraphData = async (type, selectedYear, month) => {
        try {
            const params = {
                ...filters,
            };
            const queryString = Object.entries(params)
                .filter(
                    ([_, value]) => value !== "" && value !== undefined && value !== null
                )
                .map(([key, value]) => `${key}=${value}`)
                .join("&");

            const response = await APIServices.get(
                `admin/mis_report/mom_summary?view=graph&type=${type}&year=${selectedYear}&month=${month}&${queryString}`,
                headers
            );

            if (response?.status === 200) {
                let graphData = response?.data?.list;
                if (type === "monthly") {
                    // Mapping for months
                    const monthMap = {
                        "01": "Jan",
                        "02": "Feb",
                        "03": "Mar",
                        "04": "Apr",
                        "05": "May",
                        "06": "Jun",
                        "07": "Jul",
                        "08": "Aug",
                        "09": "Sept",
                        "10": "Oct",
                        "11": "Nov",
                        "12": "Dec"
                    };

                    const allMonths = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
                    const labels = allMonths.map(month => monthMap[month]); // Map month numbers to month names (e.g. "01" -> "Jan")
                    const dataValues = allMonths?.map(month => {
                        const match = graphData.find(item => item.name === month);
                        return match ? parseInt(match.value) : 0; // Use 0 if no match found
                    });
                    const data = {
                        labels: labels,
                        datasets: [
                            {
                                label: 'MOM',
                                data: dataValues,
                                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                                borderColor: 'rgba(76, 175, 80, 1)',
                                borderWidth: 1,
                            },
                        ],
                    };
                    setGraph(data);
                } else if (type === "yearly" || type === "days") {
                    const labels = graphData.map(item => item.name);
                    const dataValues = graphData.map(item => parseInt(item.value) || 0);
                    const data = {
                        labels: labels,
                        datasets: [
                            {
                                label: 'MOM',
                                data: dataValues,
                                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                                borderColor: 'rgba(76, 175, 80, 1)',
                                borderWidth: 1,
                            },
                        ],
                    };
                    setGraph(data);
                }

            } else if (response?.status === 401) {
                logout();
                navigate("/");
            }
        } catch (error) {
            console.error("Error fetching graph data:", error);
        }
    };

    const fetchExpenseData = async (type, selectedYear, month) => {
        try {
            const response = await APIServices.get(
                `admin/mis_report/mom_expenses?type=${type}&year=${selectedYear}&month=${month}&mom_id=${momId}`,
                headers
            );

            if (response?.status === 200) {
                let expensesData = response?.data?.list;
                if (type === "monthly") {
                    // Mapping for months
                    const monthMap = {
                        "01": "Jan",
                        "02": "Feb",
                        "03": "Mar",
                        "04": "Apr",
                        "05": "May",
                        "06": "Jun",
                        "07": "Jul",
                        "08": "Aug",
                        "09": "Sept",
                        "10": "Oct",
                        "11": "Nov",
                        "12": "Dec"
                    };

                    const allMonths = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
                    const labels = allMonths.map(month => monthMap[month]); // Map month numbers to month names (e.g. "01" -> "Jan")
                    const dataValues = allMonths?.map(month => {
                        const match = expensesData.find(item => item.name === month);
                        return match ? parseInt(match.value) : 0; // Use 0 if no match found
                    });
                    const data = {
                        labels: labels,
                        datasets: [
                            {
                                label: 'MOM Expenses',
                                data: dataValues,
                                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                                borderColor: 'rgba(76, 175, 80, 1)',
                                borderWidth: 1,
                            },
                        ],
                    };
                    setExpenses(data);
                } else if (type === "yearly" || type === "days") {
                    const labels = expensesData.map(item => item.name);
                    const dataValues = expensesData.map(item => parseInt(item.value) || 0);
                    const data = {
                        labels: labels,
                        datasets: [
                            {
                                label: 'MOM Expenses',
                                data: dataValues,
                                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                                borderColor: 'rgba(76, 175, 80, 1)',
                                borderWidth: 1,
                            },
                        ],
                    };
                    setExpenses(data);
                }

            } else if (response?.status === 401) {
                logout();
                navigate("/");
            }
        } catch (error) {
            console.error("Error fetching graph data:", error);
        }
    };
    // Options for the chart
    const options = {
        responsive: true,
        layout: {
            padding: 20,
        },
        elements: {
            rectangle: {
                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                borderColor: 'rgba(76, 175, 80, 1)',       // Solid green
                borderWidth: 1,
            },
            line: {
                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                borderColor: 'rgba(76, 175, 80, 1)',
            },
            point: {
                backgroundColor: 'rgba(76, 175, 80, 1)',  // Green color with transparency
                borderColor: 'rgba(76, 175, 80, 1)',
            }
        },
        backgroundColor: 'white',
        scales: {
            x: {
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                },
                ticks: {
                    color: 'black'
                }
            },
            y: {
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                },
                ticks: {
                    color: 'black'
                }
            },
        },
    };

    const optionsExpenses = {
        responsive: true,
        layout: {
            padding: 20, // Add padding around the chart area
        },
        elements: {
            rectangle: {
                backgroundColor: 'rgba(75, 192, 192, 0.8)', // Slightly darker bar color for better visibility on white
                borderColor: 'rgba(75, 192, 192, 1)', // Border color
                borderWidth: 1, // Border width
            },
            line: {
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 1)',
            },
            point: {
                backgroundColor: 'rgba(75, 192, 192, 1)',
                borderColor: 'rgba(75, 192, 192, 1)',
            }
        },
        // Chart canvas background color
        backgroundColor: 'white', // Set canvas background to white
        scales: {
            x: {
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)', // Light grid lines for the X-axis
                },
                ticks: {
                    color: 'black' // Ensure x-axis labels are black
                }
            },
            y: {
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)', // Light grid lines for the Y-axis
                },
                ticks: {
                    color: 'black' // Ensure y-axis labels are black
                }
            },
        },
    };
    // Function to download the chart with white background
    const downloadChart = () => {
        const chart = chartRef.current;
        if (chart) {
            // Get the canvas element
            const canvas = chart.canvas;

            // Create a temporary canvas with a white background
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            // Fill the temporary canvas with white
            tempCtx.fillStyle = 'white';
            tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

            // Draw the chart onto the temporary canvas
            tempCtx.drawImage(canvas, 0, 0);

            // Get the image URL from the temporary canvas
            const imageURL = tempCanvas.toDataURL('image/png');

            // Create a download link
            const link = document.createElement('a');
            link.href = imageURL;
            const currentTimestamp = Date.now();
            link.download = currentTimestamp + '_chart.png';

            // Trigger the download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const downloadEChart = () => {
        const chart = chartERef.current;
        if (chart) {
            // Get the canvas element
            const canvas = chart.canvas;

            // Create a temporary canvas with a white background
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            // Fill the temporary canvas with white
            tempCtx.fillStyle = 'white';
            tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

            // Draw the chart onto the temporary canvas
            tempCtx.drawImage(canvas, 0, 0);

            // Get the image URL from the temporary canvas
            const imageURL = tempCanvas.toDataURL('image/png');

            // Create a download link
            const link = document.createElement('a');
            link.href = imageURL;
            const currentTimestamp = Date.now();
            link.download = currentTimestamp + '_chart.png';

            // Trigger the download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const downloadGraphAsImage = async () => {
        if (graphSectionRef.current) {
            try {
                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.flexDirection = 'column';
                container.style.alignItems = 'center';
                container.style.backgroundColor = '#fff';


                // Clone the graph section
                const graphClone = graphSectionRef.current.cloneNode(true);

                // Remove UI-only elements
                const elementsToRemove = graphClone.querySelectorAll('.gr_report');
                elementsToRemove.forEach(el => el.remove());

                // Append modified DOM to container
                container.appendChild(graphClone);

                // Temporarily add to DOM for image capture
                document.body.appendChild(container);

                const dataUrl = await toPng(container, { cacheBust: true });
                const link = document.createElement('a');
                const timestamp = new Date().toISOString().replace(/[^\w\s.]/gi, '');
                link.download = `${timestamp}_mis_report_graph.png`;
                link.href = dataUrl;
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                document.body.removeChild(container);
            } catch (error) {
                console.error('Error downloading graph as image:', error);
            }
        }
    };
    return (
        <>
            {permissionscontext.view ? (
                <>
                    <div className='momList_inner todo_list_inner'>
                        <div className='mom_header d-flex align-items-center justify-content-between mb-3'>
                            <h1 className='font_blue_18 font-600'>MIS Report</h1>
                            <ul className="d-flex align-items-center mom_filter ">
                                <li>
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item">
                                            <a className={`nav-link pointer ${activeSection === "tabs-1" ? "active" : ""}`} onClick={() => setActiveSection("tabs-1")} role="tab">
                                                Graphical Report
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={`nav-link pointer ${activeSection === "tabs-2" ? "active" : ""}`} onClick={() => setActiveSection("tabs-2")} role="tab">
                                                Textual Report
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>

                        </div>
                        <div className="tab-content">

                            <div className={`tab-pane ${activeSection === "tabs-1" ? "active" : ""}`} id="tabs-1" role="tabpanel">

                                <div className="MisReport_graph">
                                    <Row className="align-items-start">
                                        <Col md={12} lg={8}>
                                            <div className="mis_barChart pt-3">
                                                <div className="position-relative d-flex align-items-center justify-content-between">
                                                    <h2 className="font_blue_18 font-600 mb-3  mt-2">Summary of Minutes of Meeting</h2>
                                                
                                                <ul className="d-flex justify-content-end gr_report mom_filter">
                                                    <Col col={2} md={2}>
                                                        <Form.Group className="mb-0">
                                                            
                                                            <Form.Select
                                                                name="type"
                                                                onChange={handleTypeChange}
                                                                value={type}
                                                            >
                                                                <option value="yearly">Yearly</option>
                                                                <option value="monthly">Monthly</option>
                                                                <option value="days">Days</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {(type === "monthly" || type === 'days') && (
                                                        <Col col={2} md={2}>
                                                            <Form.Group className="mb-0">
                                                               
                                                                <Form.Select
                                                                    name="year"
                                                                    value={selectedYear}
                                                                    onChange={handleYearChange}
                                                                >
                                                                    <option>Select Year</option>
                                                                    {years.map((year) => (
                                                                        <option key={year} value={year}>
                                                                            {year}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    {type === "days" && (
                                                        <Col col={2} md={2}>
                                                            <Form.Group className="mb-0">
                                                               
                                                                <Form.Select
                                                                    name="month"
                                                                    value={month ? month : ''}
                                                                    onChange={handleMonthChange}
                                                                >
                                                                    <option>Select Month</option>
                                                                    <option key="1" value="01">January</option>
                                                                    <option key="2" value="02">February</option>
                                                                    <option key="3" value="03">March</option>
                                                                    <option key="4" value="04">April</option>
                                                                    <option key="5" value="05">May</option>
                                                                    <option key="6" value="06">June</option>
                                                                    <option key="7" value="07">July</option>
                                                                    <option key="8" value="08">August</option>
                                                                    <option key="9" value="09">September</option>
                                                                    <option key="10" value="10">October</option>
                                                                    <option key="11" value="11">November</option>
                                                                    <option key="12" value="12">December</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                    <li className="d-flex align-items-center cursor-pointer" onClick={() => setShowFilter(true)}>
                                                        Filter By <img src="/images/Sort.svg" className="img-fluid ms-2" alt="Sort" />
                                                    </li>
                                                </ul>
                                                </div>
                                                <Bar ref={chartRef} data={graph} options={options} />
                                                <div className="d-flex justify-content-end">
                                                <button onClick={downloadChart} className="btn blue_border btn btn-primary"><RiDownloadCloudFill className="me-2" />Download</button>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={12} lg={4}>
                                            <div className="mis_paiChart" ref={graphSectionRef}>
                                                <h2 className="font_blue_18 font-600 mb-3">Top Categories</h2>
                                                <div className="position-relative pai_chart_inner">
                                                    <PieChart width={200} height={200}>
                                                        <Pie
                                                            data={otherData} // Your category data
                                                            cx="50%" // Center of the pie chart
                                                            cy="50%" // Center of the pie chart
                                                            innerRadius={80} // Inner radius for the donut effect
                                                            outerRadius={100} // Outer radius for the donut effect
                                                            dataKey="value" // The key representing the value for each segment
                                                            startAngle={90} // Starting angle of the chart
                                                            endAngle={-270} // Ending angle of the chart
                                                        >
                                                            {/* Map through data and render each cell with a different color */}
                                                            {otherData && otherData.length > 0 && otherData.map((entry, index) => (
                                                                <Cell key={`cell-${index}`} fill={entry.color} />
                                                            ))}
                                                        </Pie>
                                                        <Tooltip /> {/* Show tooltips on hover */}
                                                    </PieChart>

                                                    {/* Display total value */}
                                                    <div className="total_text font_blue_14">Total <br />
                                                        <p className="font_blue_18 font-500">{otherTotal}</p>
                                                    </div>

                                                </div>

                                                {/* Display category details */}
                                                <div className="mt-3">
                                                    {otherData && otherData.length > 0 && otherData.map((item, index) => (
                                                        <div key={index} className="d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <span
                                                                    style={{
                                                                        display: "inline-block",
                                                                        width: "10px",
                                                                        height: "10px",
                                                                        backgroundColor: item.color, // Show color dot
                                                                        marginRight: "8px",
                                                                        borderRadius: "50%", // Circle shape
                                                                    }}
                                                                ></span>
                                                                <span className="font_blue_14">{item.name}</span> {/* Category name */}
                                                            </div>
                                                            <span className="font_blue_14">{item.value}</span> {/* Category value */}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="align-items-start mt-4">
                                        <Col md={12} lg={12}>
                                            <div className="mis_barChart pt-3">
                                                <div className="position-relative d-flex align-items-center justify-content-between">
                                                    <h2 className="font_blue_18 font-600 mb-3  mt-2"> Minutes of Meeting Expenses</h2>
                                               
                                                <ul className="d-flex justify-content-end gr_report mom_filter mt-2">
                                                    <Col col={2} md={2}>
                                                        <Form.Group className="mb-3">
                                                            
                                                            <Form.Select
                                                                name="type"
                                                                onChange={handleExpensesTypeChange}
                                                                value={expensestype}
                                                            >
                                                                <option value="yearly">Yearly</option>
                                                                <option value="monthly">Monthly</option>
                                                                <option value="days">Days</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {(expensestype === "monthly" || expensestype === 'days') && (
                                                        <Col col={2} md={2}>
                                                            <Form.Group className="mb-3">
                                                                
                                                                <Form.Select
                                                                    name="year"
                                                                    value={selectedExpensesYear}
                                                                    onChange={handleExpensesYearChange}
                                                                >
                                                                    <option>Select Year</option>
                                                                    {expensesYears.map((year) => (
                                                                        <option key={year} value={year}>
                                                                            {year}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    {expensestype === "days" && (
                                                        <Col col={2} md={2}>
                                                            <Form.Group className="mb-3">
                                                               
                                                                <Form.Select
                                                                    name="month"
                                                                    value={expensesmonth ? expensesmonth : ''}
                                                                    onChange={handleExpensesMonthChange}
                                                                >
                                                                    <option>Select Month</option>
                                                                    <option key="1" value="01">January</option>
                                                                    <option key="2" value="02">February</option>
                                                                    <option key="3" value="03">March</option>
                                                                    <option key="4" value="04">April</option>
                                                                    <option key="5" value="05">May</option>
                                                                    <option key="6" value="06">June</option>
                                                                    <option key="7" value="07">July</option>
                                                                    <option key="8" value="08">August</option>
                                                                    <option key="9" value="09">September</option>
                                                                    <option key="10" value="10">October</option>
                                                                    <option key="11" value="11">November</option>
                                                                    <option key="12" value="12">December</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    <Col col={2} md={2}>
                                                        
                                                        <Form.Select
                                                            name="mom_id"
                                                            value={momId}
                                                            onChange={handleMOMChange}
                                                        >
                                                            <option value="">Select MOM </option>
                                                            {momData?.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.agenda}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Col>
                                                </ul>
                                                </div>
                                                <Bar ref={chartERef} data={expenses} options={optionsExpenses} />
                                                <div class="d-flex justify-content-end">
                                                 <button onClick={downloadEChart} className="btn blue_border btn btn-primary"><RiDownloadCloudFill className="me-2" />Download</button>
                                                </div>
                                            </div>
                                        </Col>

                                    </Row>
                                </div>

                            </div>

                            <div className={`tab-pane ${activeSection === "tabs-2" ? "active" : ""}`} id="tabs-2" role="tabpanel">
                                <ul className="d-flex justify-content-end mom_filter mt-2">

                                    <li className="d-flex align-items-center cursor-pointer" onClick={() => setShowTableFilter(true)}>
                                        Filter By <img src="/images/Sort.svg" className="img-fluid ms-2" alt="Sort" />
                                    </li>
                                </ul>
                                <div className='todoList_table'>
                                    <div className="table-responsive">
                                        <Table>
                                            <thead className="table-dark">
                                                <tr>
                                                    <th>Sr.No</th>
                                                    <th>Title</th>
                                                    <th>Date</th>
                                                    <th>Channel Parnter</th>
                                                    <th>RM</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {momList.map((user, index) => (
                                                    <tr key={user.id}>
                                                        <td>{(currentPage - 1) * limit + index + 1}</td>
                                                        <td>{capitalizeFirstLetter(user.agenda)}</td>
                                                        <td>
                                                            {`${formatDateDMY(
                                                                user?.date
                                                            )}`}
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <p className="textTransform">{user?.channel_partner_name}</p>
                                                            </div>
                                                        </td>
                                                        <td className="textTransform">{`${user.relationship_manager_first_name} ${user.relationship_manager_last_name}`}</td>

                                                        <td>
                                                            <button
                                                                disabled={!permissionscontext.view}
                                                                style={{
                                                                    border: "none",
                                                                    background: "transparent",
                                                                    padding: 0,
                                                                    cursor: !permissionscontext.view
                                                                        ? "not-allowed"
                                                                        : "pointer",
                                                                    opacity: !permissionscontext.view
                                                                        ? 0.5
                                                                        : 1,
                                                                }}
                                                                onClick={() =>
                                                                    navigate(`/admin/mom-details/${user.id}`)
                                                                }
                                                            >
                                                                <img
                                                                    src="/images/Eye.svg"
                                                                    className="img-fluid"
                                                                    alt="Eye.svg"
                                                                />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="position-relative misPage_footer ">
                                    {activeTab === "listView" && count > 10 && (
                                        <Paginator
                                            currentPage={currentPage}
                                            totalPages={totalCount}
                                            onPageChange={handlePageChange}
                                        />
                                    )}

                                </div>
                            </div>

                        </div>

                    </div>
                    {showFilter && (
                        <Filter
                            appliedFilters={filters}
                            show={showFilter}
                            onHide={() => setShowFilter(false)}
                            onApplyFilter={(filterData) => {
                                setFilters(filterData);
                                setShowFilter(false);
                            }}
                            onClear={() => {
                                setFilters({});
                                setShowFilter(false);
                            }}
                        />
                    )}
                    {showTableFilter && (
                        <MomListFilter
                            appliedFilters={filters}
                            show={showTableFilter}
                            onHide={() => setShowTableFilter(false)}
                            onApplyFilter={(filterData) => {
                                setFilters(filterData);
                                setShowTableFilter(false);
                            }}
                            onClear={() => {
                                setFilters({});
                                setShowTableFilter(false);
                                setSelectedRange("")
                            }}
                            setSelectedRange={setSelectedRange}
                            selectedRange={selectedRange}
                        />
                    )}
                </>)
                : <Notauthorized />
            }
        </>
    );
};

export default MisReport;

